import { gql } from '@apollo/client';

export const GET_AUDIT_REPORT = gql`
  query GetAuditReport($communityId: ID!, $auditSessionId: ID!) {
    community(id: $communityId) {
      id
      name
      communityGroupId
      logoUrl
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
      }
      auditSession(sessionId: $auditSessionId) {
        id
        name
        status
        createdBy
        createdAt
        completedAt
        sampleParameters {
          communityId
          samplingParameters {
            confidenceLevel
            marginOfError
            populationProportion
            timeframe {
              start
              end
            }
          }
          filters {
            languages
            topics
            labels
            labelSeverities
            contentTypes
          }
        }
        auditReports {
          id
          type
          createdBy
          createdAt
          lastModifiedBy
          lastModifiedAt
          name
          status
          auditSessionId
          filters {
            timeframe {
              start
              end
            }
            communityId
            auditorIds
          }
          metrics {
            overall {
              precision
              recall
              f1Score
              accuracy
              labelCorrectnessCount
              labelCorrectnessPercentage
              policyCorrectnessCount
              policyCorrectnessPercentage
            }
            byLabel {
              label
              metrics {
                precision
                recall
                f1Score
                accuracy
                labelCorrectnessCount
                labelCorrectnessPercentage
                policyCorrectnessCount
                policyCorrectnessPercentage
              }
            }
            byCommunity {
              communityId
              metrics {
                precision
                recall
                f1Score
                accuracy
                labelCorrectnessCount
                labelCorrectnessPercentage
                policyCorrectnessCount
                policyCorrectnessPercentage
              }
            }
            byPolicy {
              policyId
              policyName
              triggeredCorrectnessCount
              triggeredCorrectnessPercentage
              nonTriggeredCorrectnessCount
              nonTriggeredCorrectnessPercentage
              overallCorrectnessCount
              overallCorrectnessPercentage
            }
            policySummary {
              totalPoliciesAssessed
              triggeredPoliciesCount
              nonTriggeredPoliciesCount
              triggeredPoliciesCorrectCount
              triggeredPoliciesCorrectPercentage
              nonTriggeredPoliciesCorrectCount
              nonTriggeredPoliciesCorrectPercentage
            }
            disagreements {
              count
              percentage
              byCommunity {
                communityId
                count
              }
            }
            labelComparison {
              exactMatchCount
              exactMatchPercentage
              labelsMissingCount
              labelsMissingPercentage
              additionalLabelsCount
              additionalLabelsPercentage
              bothMissingAndAdditionalCount
              bothMissingAndAdditionalPercentage
            }
          }
        }
      }
    }
  }
`;
